import classes from './ResultsCount.module.scss'

export interface Props {
  value: number|string
  label?: string
}

const ResultsCount = ({
  value,
  label = 'Result'
}: Props) =>
  <span className={classes.ResultsCount}>
    {value}
    {' '}
    <span className={classes.staticText}>
      {label}{value !== 1 && 's'}
    </span>
  </span>

export default ResultsCount
